import { makeStyles } from "@material-ui/core/styles";

export const useSelectFieldStyles = makeStyles(() => ({
  checkbox: {
    marginLeft: "10px",
  },
  hidden: {
    display: "none",
  },
  option: {
    margin: "0",
  },
}));
